import { z } from 'zod';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';

export type CarPlacementSaleReport = {
    id: number,
    year: number,
    month: number,
    file_name: string,
    created_at: string,
    updated_at: string,
    dealer: {
        id: number,
        sap_code: string,
        name: string,
        email: string,
    },
};

export type CarPlacementSaleReportsRequestFilter = {
    dealer_id?: number,
    year?: number,
    month?: number,
    page?: number,
    sort?: Record<string, string>[],
};

export type CarPlacementSaleReportsPaginator = {
    data: CarPlacementSaleReport[],
    meta: PaginationMeta,
};

export const CarPlacementSaleReportsPaginatorSchema = z.object({
    data: z.object({
        id: z.number(),
        year: z.number(),
        month: z.number(),
        file_name: z.string(),
        created_at: z.string(),
        updated_at: z.string(),
        dealer: z.object({
            id: z.number(),
            sap_code: z.string(),
            name: z.string(),
            email: z.string(),
        }),
    }).array(),
    meta: PaginationMetaSchema,
});
